import React, { useState, useEffect, Fragment } from 'react'
import { Input, Label } from 'reactstrap'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

const CommissionFilters = ({ types, handleFilter, filters }) => {
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [searchType, setSearchType] = useState('')
  const { t } = useTranslation()
  useEffect(() => {
    let filterObject = { ...filters }

    if (fromDate != null) {
      filterObject['from_date'] = fromDate
    }
    if (toDate != null) {
      filterObject['to_date'] = toDate
    }

    if (searchType != null) {
      filterObject['searchType'] = searchType
    }
    // console.log('filterObject', filterObject)

    handleFilter(filterObject)
    // eslint-disable-next-line
  }, [fromDate, toDate, searchType])

  return (
    <Fragment>
      <div className="product-filter">
        <h6 className="f-w-600">{t("partner.searchType")}</h6>
        <div className="checkbox-animated mt-0">
          {types.map((type, index) => {
            return (
              <Label className="d-block" key={type.id}>
                <Input
                  className="radio_animated"
                  id={type.id}
                  type="radio"
                  name="type"
                  onClick={(e) => {
                    setSearchType(type.id)
                  }}
                />
                {type.name}
              </Label>
            )
          })}
        </div>
      </div>

      <div className="product-filter">
        <h6 className="f-w-600">{t("partner.From")}</h6>
        <Input
          className="form-control digits"
          type="date"
          defaultValue={fromDate}
          onChange={(e) => {
            setFromDate(moment(e.currentTarget.value).format("YYYY-MM-DD"))
          }}
        />
      </div>
      <div className="product-filter">
        <h6 className="f-w-600">{t("partner.To")}</h6>
        <Input
          className="form-control digits"
          type="date"
          defaultValue={toDate}
          onChange={(e) => {
            setToDate(moment(e.currentTarget.value).format("YYYY-MM-DD"))
          }}
        />
      </div>
    </Fragment>
  )
}

export default CommissionFilters
